export const ROUTES = {
  LOGIN: {
    SIGN_IN: '/',
    SSO: '/sso',
    DISCONNECTED: '/?disconnected=true',
    FORGOT_PASSWORD: '/forgot-password',
    NEW_PASSWORD: '/new-password',
    ACTIVATE_USER: '/activate-user',
  },
  PANEL: {
    NEWS: '/posts',
  },
  SETTINGS: {
    GENERAL: '/settings/general',
    GENERIC_CONTENT: '/settings/generic-content',
  },
  PROFILE: {
    HOME: '/profile',
    PASSWORD: '/profile/password',
    PREFERENCES: '/profile/preferences',
    ACCESS: '/profile/access',
  },
  REGISTERS: {
    USERS: '/registers/users',
    FILES: '/registers/files',
  },
  SSO: {
    APPLICATIONS: '/sso/applications',
    ACCOUNTS: '/sso/accounts',
    ACCESS: '/sso/access',
  },
}
